const config = {
  apiGateway: {
    REGION: 'eu-west-1',
    INTERNAL_API_URL: 'https://jxwn8qk97l.execute-api.eu-west-1.amazonaws.com/prod',
    TEAM_API_URL: 'https://lfkdkzazkh.execute-api.eu-west-1.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'hotfix/UP1-399-team-owner-inactive-user',
    HOSTNAME: 'https://teams-service.testing.eurecovery.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.eurecovery.forwoodsafety.com',
    WEBSOCKET: 'wss://mx3s7li7i2.execute-api.eu-west-1.amazonaws.com/testing'
  },
};

export default config;
